import { render, staticRenderFns } from "./CourtOrders.vue?vue&type=template&id=0310607f&"
import script from "./CourtOrders.vue?vue&type=script&lang=js&"
export * from "./CourtOrders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports